<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="ODABIRAVANSA.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <div class="row">
      <div class="col-md-12">
          <yt-fw-default-table
          *ngIf="modelData!=null && modelData.MainList!=null"
          [Config]="Config"
          [Items]="items"
          [TableColumns]="modelData.MainList.TableColumns"      
          [Condensed]="CondensedTable"
          [ShowLoader]="MainItemsLoading"
          (RefreshDataClicked)="RefreshData()"
          [RowColors]="rowColors"
        >
        </yt-fw-default-table>      
      </div>
    </div>
    <div class="containter">
      <div class="row">
          <div class="col-md-12">
            <div class="padding: 0.5rem">	
                <span translate="LEGENDA.SINGULAR"></span>
            </div>
            <div class="row col-md-6" *ngFor="let legend of legends">
              <div style="padding: 0.5rem; position: relative;">
                <div [style.backgroundColor]="legend.color" style="width: 1rem; height: 1rem; position: absolute;"></div>
                <div style="position: relative; left: 1rem; padding-left: 0.5rem; height: 1.25rem; line-height: 1.25 rem; font-size: 0.9rem;"><span translate={{legend.name}}></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>